import * as Sentry from "@sentry/nextjs";

export const SENTRY_EVENT_TAG = "request_error";

export interface OnSentryCatchParam {
	request: string;
	error: string;
}

/**
 * @param value string 接口名称或者事件名称
 */
export const setEventTag = (value: string) => {
	Sentry.configureScope((scope) => {
		scope.setTag(SENTRY_EVENT_TAG, value);
	});
	Sentry.setTag(SENTRY_EVENT_TAG, value);
};
export interface SentryCatchRequestParam {
	request: string;
	error: string;
}

export const setSentryCatchOnRequest = ({ request, error }: SentryCatchRequestParam) => {
	setEventTag(request);
	Sentry.captureException(error);
};

export function s<Q, T>(fn: (req: Q, ...args: any[]) => Promise<T>) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const transaction = Sentry.getCurrentHub().getScope().getTransaction();
	const span = transaction?.startChild({
		op: "function:operation",
		description: `operation: ${fn.name} `,
	});
	return function wrapped(payload?: Q, ...args): Promise<null | T> {
		// eslint-disable-next-line prefer-rest-params
		return (fn.call(this, payload, ...args) as Promise<T>)
			.then((res: T) => {
				return res;
			})
			.finally(() => {
				span?.finish();
			});
	};
}

export function addDomSpansEvent(requiredParameter, parameter?) {
	const { type, positionId } = requiredParameter;
	const transaction = Sentry.getCurrentHub().getScope().getTransaction();
	const span = transaction?.startChild({
		op: "domcount",
		description: `dom: ${type}-${positionId} `,
		...parameter,
	});

	return span;
}
